import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

export const LoaderFullPage = () => (
	<div style={{
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100vh',
		fontSize: '1.2rem'
	}}>
		<Spin indicator={<LoadingOutlined spin />} />
	</div>
);